export const SET_FORM_DISPLAY_ERROR = 'Editor/Form/SET_FORM_DISPLAY_ERROR';
